const JobsRoundedIcon = () => {
  return (
    <svg
      width="49"
      height="50"
      viewBox="0 0 49 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="49" height="49" rx="12" fill="var(--primaryLight)" />
      <path
        d="M33.1062 17.2313H28.4753V15.1724C28.4753 14.192 27.7525 13.3945 26.864 13.3945H22.136C21.2475 13.3945 20.5246 14.192 20.5246 15.1724V17.2313H15.8938C14.7141 17.2313 13.7544 18.2903 13.7544 19.5919V31.6656C13.7544 32.9672 14.7141 34.0261 15.8938 34.0261H33.1062C34.2859 34.0261 35.2456 32.9672 35.2456 31.6656V19.5919C35.2456 18.2903 34.2859 17.2313 33.1062 17.2313ZM21.8895 15.1724C21.8895 15.0224 22.0001 14.9004 22.136 14.9004H26.864C26.9999 14.9004 27.1105 15.0225 27.1105 15.1724V17.2313H21.8895V15.1724ZM15.1192 19.5919C15.1192 19.1206 15.4667 18.7372 15.8938 18.7372H33.1062C33.5333 18.7372 33.8808 19.1206 33.8808 19.5919V20.7063C33.8808 21.7516 33.2456 22.6856 32.336 22.9778L25.1986 25.2707C24.7416 25.4176 24.2585 25.4176 23.8014 25.2707L16.664 22.9778C15.7545 22.6856 15.1192 21.7516 15.1192 20.7063V19.5919ZM33.1062 32.5203H15.8938C15.4667 32.5203 15.1192 32.1369 15.1192 31.6656V23.7722C15.4631 24.0654 15.8551 24.2864 16.2825 24.4237C24.1668 26.9565 23.7616 26.8868 24.5 26.8868C25.2481 26.8868 24.8239 26.9595 32.7175 24.4237C33.1449 24.2864 33.5369 24.0654 33.8808 23.7722V31.6656C33.8808 32.1368 33.5333 32.5203 33.1062 32.5203Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        stroke-width="0.4"
      />
    </svg>
  );
};

export default JobsRoundedIcon;
